// extracted by mini-css-extract-plugin
export default {"verticalStack":"style--verticalStack--a1e7b4"};